<template>
	<section>
		<div class="index-banner-top">
			<Header></Header>
			<div class="m-doc">
				<p>欧朋浏览器</p>
				<p>挖掘<span style="color: rgba(211, 77, 58, 1);">有趣的</span>价值</p>
				<p><router-link :to="{path: '/downloadmobile'}">下载手机浏览器</router-link></p>
			</div>
		</div>
		<div class="index-left-radius">
			<img src="../../../static/images/index-left-radius.png" alt="">
		</div>
		<div class="about-us">
			<p>ABOUT US</p>
			<p>关于我们</p>
			<p>古语有云：“有朋自远方来，不亦乐乎”。欧洲的“欧”，朋友的“朋”，2011 年 8 月，我们在中国发布了中文品牌—欧朋，从手机端浏览器开始，发展了全平台的欧朋浏览器，并建立了欧朋广告平台。</p>
			<p>
				<img src="../../../static/images/index_aboutus_1.png" alt="">
				<img src="../../../static/images/index_aboutus_3.png" alt="">
				<img src="../../../static/images/index_aboutus_2.png" alt="">
			</p>
		</div>
		<div class="index-right-radius">
			<img src="../../../static/images/index-right-radius.png" alt="">
		</div>
		<div class="culture">
			<div class="top">
				<p>ENTERPRISE CULTURE</p>
				<p>企业文化</p>
			</div>
			<div class="bottom">
				<div class="left">
					<p>我们是一群满怀激情、勇于开拓的梦想家。勇于尝试未知，敢于突破常规，不断挑战技术的极限。每一位用户，都是我们珍视如友的宝贵伙伴。</p>
					<p>在未来，我们将继续作为探索者和引领者，不仅追求技术的卓越，更致力于将这份卓越转化为用户触手可及的美好。</p>
				</div>
				<div class="right">
					<img src="../../../static/images/corporate_culture.png" alt="">
				</div>
			</div>
		</div>
		<div class="index-left-radius-1">
			<img src="../../../static/images/index-left-radius_1.png" alt="">
		</div>
		<div class="pretner">
			<p>COOPERATIVE PARTNER</p>
			<p>合作伙伴</p>
			<p>
				<img src="../../../static/images/cooperative_partner_3.png" alt="">
				<img src="../../../static/images/cooperative_partner_2.png" alt="">
				<img src="../../../static/images/cooperative_partner_5.png" alt="">
				<img src="../../../static/images/cooperative_partner_7.png" alt="">
			</p>
		</div>
		<div class="index-right-radius-2">
			<img src="../../../static/images/index-right-radius_1.png" alt="">
		</div>
		<Footer></Footer>
	</section>
</template>

<script>
import Header from '../modules/Header';
import Footer from '../modules/Footer';
export default {
	name: 'Home',
	components: {
		Header,
		Footer
	},
	data() {
		return {
			//
		}
	},
	computed: {}
}
</script>

<style scoped>
.index-banner-top {
	width: 100%;
    height: 2.5rem;
    position: relative;
    background: url(../../../static/images/index-top-1600.png) no-repeat;
    background-size: 100% 100%;
}

.m-doc {
	width: 2rem;
	margin-left: 0.15rem;
}
.m-doc a {
	color: #fff;
}
.m-doc p:nth-child(1) {
	font-size: 0.28rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
}
.m-doc p:nth-child(2) {
	font-size: 0.14rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 1);
	padding: 0.1rem 0 0 0;
}
.m-doc p:nth-child(3) {
	width: 1.2rem;
	height: 0.4rem;
	opacity: 1;
	font-size: 0.12rem;
	color: #fff;
	line-height: 0.4rem;
	text-align: center;
	border-radius: 30px;
	margin: 0.15rem 0 0 0;
	background: rgba(247, 67, 68, 1);
}
.about-us, .culture, .pretner {
	margin: 0.3rem 0.15rem 0 0.15rem;
}
.about-us p, .culture p, .pretner p{
	width: 100%;
	font-weight: 400;
	text-align: center;
}
.about-us p:nth-child(1), .culture .top p:nth-child(1), .pretner p:nth-child(1) {
	font-size: 0.14rem;
	color: rgba(247, 67, 68, 1);
}
.about-us p:nth-child(2), .culture .top p:nth-child(2), .pretner p:nth-child(2){
	font-size: 0.14rem;
	color: rgba(0, 0, 0, 1);
	margin: 0.05rem 0 0.2rem 0;
}
.about-us p:nth-child(3){
	font-size: 0.12rem;
	font-weight: 400;
	letter-spacing: 1.2px;
	color: rgba(51, 51, 51, 1);
	text-align: justify;
	vertical-align: top;
}
.about-us p:nth-child(4) {
	display: flex;
	justify-content: space-between;
	margin-top: 0.2rem;
}
.about-us p:nth-child(4) img {
	width: 1.1rem;
}
.culture .left {
	width: 55%;
	margin-right: 0.2rem;
}
.culture .left p:nth-child(1), .culture .left p:nth-child(2){
	font-size: 0.12rem;
    font-weight: 400;
    letter-spacing: 1.2px;
	line-height: 0.17rem;
    color: rgba(51, 51, 51, 1);
    text-align: justify;
    vertical-align: top;
}
.culture .left p:nth-child(2) {
	margin-top: 0.1rem;
}
.culture .bottom {
	display: flex;
	justify-content: space-around;
	align-items: center;
}
.culture .right {
	width: 45%;
	text-align: center;
}
.culture .right img {
	width: 1.6rem;
	height: 1.6rem;
	margin: 0 auto;
}
.pretner  p:nth-child(3) {
	display: flex;
	justify-content: space-between;
}
.pretner  p:nth-child(3) img {
	width: 0.85rem;
}

.index-left-radius  {
	position: absolute;
	width: 1rem;
	height: 2rem;
	left: 0;
	z-index: -1;
}
.index-right-radius {
	right: 0;
	top: 5rem;
	position: absolute;
	width: 1rem;
	height: 2rem;
	z-index: -1;
}
.index-left-radius-1 {
	position: absolute;
	width: 1rem;
	height: 2rem;
	left: 0;
	top: 7rem;
	z-index: -1;
}
.index-right-radius-2 {
	right: 0;
	top: 9rem;
	position: absolute;
	width: 1rem;
	height: 2rem;
	z-index: -1;
}
img{
	width: 100%;
	height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Home.vue